import { render, staticRenderFns } from "./WelfareBreadcrumb.vue?vue&type=template&id=1c650f0d"
import script from "./WelfareBreadcrumb.vue?vue&type=script&lang=js"
export * from "./WelfareBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./WelfareBreadcrumb.vue?vue&type=style&index=0&id=1c650f0d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports